import React from "react";
import useNotifyWaitingRoomUsers from "./hooks/useNotifyWaitingRoomUsers";
import { Notification } from "../Notifications";

export default function ({ theme, isAdmin }) {
  useNotifyWaitingRoomUsers(isAdmin);

  return <Notification />;
}
